module.exports = __webpack_public_path__ + "img/perks_J relocation.49053130.jpg";